<template>
  <div class="profile_group_info">
    <div class="line row">
      <div class="col-md-1 col-sm-2">
        <fg-input :value="group.id" label="ID" type="text" :readonly="true" />
      </div>
      <div class="col-md-5 col-sm-4">
        <fg-input :value="group.name" :label="translate('simcard_profile_group.name')" type="text" :readonly="true" />
      </div>
      <div class="col-md-3 col-sm-3">
        <fg-input :value="group.group_type" :label="translate('simcard_profile_group.group_type')" type="text" :readonly="true" />
      </div>
      <div class="col-md-3 col-sm-3">
        <fg-input :value="group.members_count" :label="translate('simcard_profile_group.members_count')" type="text" :readonly="true" />
      </div>
    </div>
    <div class="line row">
      <div class="col-md-4 col-sm-4 form-group">
        <label>{{ translate('client.one') }}</label>
        <tree-select :value="group.client_id" :options="client_list" :multiple="false" :disabled="true" :placeholder="translate('client.one')" />
      </div>
      <div class="col-md-4 col-sm-4">
        <fg-input :value="group.client_order_id" :label="translate('simcard_profile_group.client_order_id')" type="text" :readonly="true" />
      </div>
      <div class="col-md-4 col-sm-4">
        <fg-input :value="translate(group.is_archived ? 'yes' : 'no')" :label="translate('simcard_profile_group.is_archived')" type="text" :readonly="true" />
      </div>
    </div>
    <div class="line row">
      <div class="col-md-4 col-sm-4">
        <fg-input :value="get_date(group.created_at)" :label="translate('simcard_profile.ts_create')" type="text" :readonly="true" />
      </div>
      <div class="col-md-4 col-sm-4">
        <fg-input :value="get_date(group.updated_at)" :label="translate('simcard_profile.ts_update')" type="text" :readonly="true" />
      </div>
      <div class="col-md-4 col-sm-4">
        <fg-input :value="group.archived_at ? get_date(group.archived_at) : ''" :label="translate('simcard_profile_group.archived_at')" type="text" :readonly="true" />
      </div>
    </div>
    <div class="form-group">
      <label>{{ translate('simcard_profile_group.description') }}</label>
      <textarea class="input_text" rows="3" :value="group.description" readonly />
    </div>

    <!--
    <label>{{ translate('simcard_profile_group.members') }} ({{ total }})</label>
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th class="w50" scope="col">ID</th>
            <th scope="col">{{ translate('simcard_profile.iccid') }}</th>
            <th scope="col">{{ translate('simcard_profile.msisdn') }}</th>
            <th scope="col">{{ translate('simcard_profile.mno') }}</th>
            <th scope="col">{{ translate('simcard_profile.oper_account') }}</th>
            <th scope="col">{{ translate('simcard_profile_group.joined_at') }}</th>
            <th class="text-left" scope="col">{{ translate('simcard_profile.comment') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="member in members" :key="member.id">
            <td class="w50" data-label="ID">{{ member.id }}</td>
            <td :data-label="translate('simcard_profile.iccid')">{{ member.iccid }}</td>
            <td :data-label="translate('simcard_profile.msisdn')">{{ member.profile?.msisdn }}</td>
            <td :data-label="translate('simcard_profile.mno')">{{ member.profile?.mno_name }}</td>
            <td :data-label="translate('simcard_profile.oper_account')">{{ member.profile?.oper_account }}</td>
            <td :data-label="translate('simcard_profile_group.joined_at')" v-html="get_date_any_lines(member.joined_at, null, 2)" />
            <td class="text-left" :data-label="translate('simcard_profile.comment')">{{ member.comment }}</td>
          </tr>
          <tr v-if="!members.length">
            <td>{{ translate('no_data') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="total > limit" class="pagination_controls">
      <button class="btn btn-info btn-fill" :disabled="offset === 0" @click="$emit('change-page', offset - limit)">
        {{ translate('simcard_profile_group.previous') }}
      </button>
      <span>{{ offset / limit + 1 }}</span>
      <button class="btn btn-info btn-fill" :disabled="offset + limit >= total" @click="$emit('change-page', offset + limit)">
        {{ translate('simcard_profile_group.next') }}
      </button>
    </div>
    -->
  </div>
</template>

<script>
export default {
  name: 'SimCardProfileGroupInfo',
  props: {
    group: Object,
    members: Array,
    total: Number,
    limit: Number,
    offset: Number
  },
  computed: {
    client_list() {
      return this.$store.getters.getClientsList.map(client => ({id: client.id, label: client.name}))
    }
  }
}
</script>

<style lang="scss" scoped>
.profile_group_info {
  display: flex;
  flex-direction: column;
  height: 100%;
  .form-group {
    margin-bottom: 10px;
  }
  .response_table {
    padding: 0;
    th, td {
      font-size: 12px;
      &.text-left {
        text-align: left;
      }
    }
  }
  .pagination_controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
  }
}
</style>
